module.exports = __webpack_public_path__ + "img/android-chrome-192x192.20d6b21e.png";